import { stringFormatter } from '@nhl/formatter-utilities';

export const addRecordSlugs = ({ data: records }) => {
    const sluggedRecords = {};
    Object.keys(records).map((record) => {
        records[record].map((category) => {
            category.recordTypeSlug = encodeURI(stringFormatter.toSlug(category.recordType.description));
        });
        sluggedRecords[record] = records[record];
    });
    return sluggedRecords;
};
